import { apolloClient as client } from 'src/graphql/client/apollo-client';
import { AppMembershipsDocument } from 'src/graphql/actions/appMemberships/appMemberships.query';
import { UsersDocument } from 'src/graphql/actions/user/users.query';

export const refetchAppMemberships = () => {
  client.cache.evict({ fieldName: 'appMemberships' });
  client.cache.gc();
  client.refetchQueries({
    include: [AppMembershipsDocument],
  });
};

export const refetchUsers = () => {
  client.cache.evict({ fieldName: 'users' });
  client.cache.gc();
  client.refetchQueries({
    include: [UsersDocument],
  });
};
